export default "__VITE_ASSET__d9f679b2__"